<template>
  <div class="wrapper">
    <side-bar :title="title">
      <mobile-menu v-if="false" slot="content"></mobile-menu>
      <template>
        <sidebar-link
          v-for="(itemMenu, index) in menu"
          :key="index"
          :to="itemMenu.to"
        >
          <i :class="itemMenu.icon"></i>
          <p>{{ itemMenu.title }}</p>
        </sidebar-link>
      </template>

      <template slot="bottom-links">
        <li class="active" router-link-exact-active="">
          <a href="#" class="nav-link" @click="logout">
            <i class="nc-icon nc-button-power"></i>
            <p>{{ $t("panel.logout") }}</p>
          </a>
        </li>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"></dashboard-content>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TheTopNavbar.vue";
import DashboardContent from "./TheContent.vue";
import MobileMenu from "./MobileMenu.vue";
import {
  ACT_ADMIN_LOGOUT,
  GET_ADMIN_IS_AUTH,
} from "@/stores/modules/AuthAdmin/types";
import { mapGetters } from "vuex";
import adminMenu from "../../plugins/menu/admin";

export default {
  name: "TheDashboardAdminLayout",
  props: {
    title: {
      type: String,
    },
  },
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
  },
  computed: {
    menu() {
      return adminMenu;
    },

    ...mapGetters("AuthAdmin", {
      isAuthAdmin: GET_ADMIN_IS_AUTH,
    }),
  },
  watch: {
    isAuthAdmin() {
      if (!this.isAuthAdmin) {
        this.$router.push({ name: "AdminLogin" });
      }
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    async logout() {
      await this.$store.dispatch(`AuthAdmin/${ACT_ADMIN_LOGOUT}`);
    },
  },
};
</script>
